module.exports = " <div v-el:modal=\"\" class=modal _v-326e60e3=\"\"> <div class=\"modal-dialog modal-{{size}}\" _v-326e60e3=\"\"> <div class=modal-content _v-326e60e3=\"\"> <slot name=content _v-326e60e3=\"\"></slot> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-326e60e3!./~/vue-loader/lib/selector.js?type=template&index=0!./components/ui/modal.vue
// module id = 202
// module chunks = 0